import React from 'react';
// Import the hero image as a fallback for browsers that cannot play video
import heroImg from '../assets/hero.png';

function Home() {
  return (
    <>
      <section className="hero" data-aos="fade-up">
        <div className="container hero-grid">
          <div className="hero-text">
            <h1>
              Hi, I'm Viraj
              <br />
              <span>Pargaonkar</span>
            </h1>
            <h2>Senior Software Developer</h2>
            <p>
              I build scalable, performant and beautiful web applications. With a
              strong foundation in both front‑end and back‑end technologies, I
              love turning complex problems into elegant solutions.
            </p>
            <div className="hero-buttons">
              <a href="/Viraj_Pargaonkar__Resume.pdf" className="btn" download>
                Download&nbsp;Résumé
              </a>
              <a href="/contact" className="btn btn-secondary">
                Get in Touch
              </a>
            </div>
          </div>
          <div className="hero-image" data-aos="zoom-in">
            {/* Display a static illustration on the right side of the hero */}
            <img
              src={heroImg}
              alt="Abstract illustration representing creativity and code"
            />
          </div>
        </div>
      </section>
      <section className="about" data-aos="fade-up">
        <div className="container">
          <h2 className="section-title">About Me</h2>
          <p className="about-text">
            Based in San&nbsp;Jose, California USA, I am a software engineer with over
            five years of professional experience crafting user‑friendly and
            performance‑oriented web applications. My journey has taken me
            from building Java‑based manufacturing monitoring systems in India
            to architecting complex prescription management workflows at Kroger
            Health. I enjoy collaborating with designers and product teams to
            translate visions into scalable, maintainable code. When I'm not
            coding, you'll find me exploring the Bay Area’s hiking trails or
            tinkering with new frameworks.
          </p>
        </div>
      </section>
    </>
  );
}

export default Home;